enum PolicyDebugProp {
  CONVERSATION_ID = 'CONVERSATION_ID',
  ATTRIBUTE = 'ATTRIBUTE',
  POLICY_NAME = 'POLICY_NAME',
  SKILL = 'SKILL',
  AGENT = 'AGENT',
}

export default PolicyDebugProp;
